var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { QueryClient } from "react-query";
/**
 * Timeout (ms) for product-number operations that may create a publisher prefix
 * and generate a whole block of numbers server-side — far longer than ky's
 * default 10s, which would otherwise abort the request mid-generation.
 */
export var NUMBER_ASSIGN_TIMEOUT_MS = 180000;
/**
 * Timeout (ms) for the OwnCloud import trigger POST. The backend answers 202 the
 * moment it accepts the job (the 357 MB download + import run in the background),
 * so this only needs enough headroom to survive gateway buffering — well above
 * ky's default 10s, which would otherwise abort while the gateway is still
 * relaying the immediate 202 and make the import look failed.
 */
export var OWNCLOUD_IMPORT_TRIGGER_TIMEOUT_MS = 60000;
export var getHeaders = function (additionalHeaders) {
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    return (__assign({ "Content-Type": "application/json", "Cache-Control": "no-cache, no-store, must-revalidate", Pragma: "no-cache", Expires: "0" }, additionalHeaders));
};
export var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            cacheTime: 0,
            refetchOnWindowFocus: true,
            refetchOnMount: true,
        },
    },
});
